import { render, staticRenderFns } from "./InventoryTransferSettings.vue?vue&type=template&id=4e677088&scoped=true"
import script from "./InventoryTransferSettings.vue?vue&type=script&lang=ts"
export * from "./InventoryTransferSettings.vue?vue&type=script&lang=ts"
import style0 from "./InventoryTransferSettings.vue?vue&type=style&index=0&id=4e677088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e677088",
  null
  
)

export default component.exports